var map = {
	"./apple-pay.svg": "4Hzy",
	"./garmin-pay.svg": "FG8P",
	"./google-pay.svg": "58xR",
	"./lframe-pay-any-way.png": "95eP",
	"./nz_digital_wallet-apple-pay-phone.png": "hq9L",
	"./nz_digital_wallet-garmin-pay-watch.png": "AQiN",
	"./nz_digital_wallet-google-pay-phone.png": "F+05",
	"./nz_digital_wallet-samsung-pay-phone.png": "0Bj8",
	"./samsung-pay.svg": "XPUu"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+zCr";